export const defaultAddresses = [
  {
    id: 'home',
    label: 'Home',
    address: '1901 Thornridge Cir. Shiloh, Hawaii 81063',
  },
  {
    id: 'office',
    label: 'Office',
    address: '4517 Washington Ave. Manchester, Kentucky 39495',
  },
  {
    id: 'parents',
    label: "Parent's House",
    address: '8502 Preston Rd. Inglewood, Maine 98380',
  },
  {
    id: 'friend',
    label: "Friend's House",
    address: '2464 Royal Ln. Mesa, New Jersey 45463',
  },
];

export const shippingMethods = [
  {
    id: 'economy',
    label: 'Economy',
    eta: 'Estimated Arrival 25 Sep 2023',
    amount: 25,
  },
  {
    id: 'regular',
    label: 'Regular',
    eta: 'Estimated Arrival 24 Sep 2023',
    amount: 35,
  },
  {
    id: 'cargo',
    label: 'Cargo',
    eta: 'Estimated Arrival 22 Sep 2023',
    amount: 45,
  },
  {
    id: 'express',
    label: 'Express',
    eta: 'Estimated Arrival 20 Sep 2023',
    amount: 55,
  },
];

export const paymentGroups = [
  {
    title: 'Cash',
    items: [{ id: 'cash', label: 'Cash' }],
  },
  {
    title: 'Wallet',
    items: [{ id: 'wallet', label: 'Wallet' }],
  },
  {
    title: 'Credit & Debit Card',
    items: [{ id: 'card', label: 'Add Card', hasArrow: true }],
  },
  {
    title: 'More Payment Options',
    items: [
      { id: 'paypal', label: 'Paypal' },
      { id: 'apple-pay', label: 'Apple Pay' },
      { id: 'google-pay', label: 'Google Pay' },
    ],
  },
];

export function formatCurrency(value) {
  return `Rs. ${Number(value || 0).toFixed(2)}`;
}

export function buildOrderSummary(cartItems, shippingAmount = 25) {
  const amount = cartItems.reduce(
    (total, item) => total + Number(item.price || 0) * Number(item.quantity || 1),
    0
  );
  const tax = amount > 0 ? Math.max(25, Math.round(amount * 0.08)) : 0;

  return {
    amount,
    shippingAmount,
    tax,
    total: amount + shippingAmount + tax,
    promoCode: 'FR1254HGGWE',
    orderDate: 'Sep 18, 2023 | 10:00 AM',
  };
}
